import axiosPost from "../axiosPost";

export const horarioIns = async ({
    gateHorarioNombre,
    gateHorarioDescripcion = null,
    gateHorarioCod
}, credentials) => {
    const body = {
        service: "GateHorarioIns",
        params: {
            merchantId: credentials.merchantId,
            gateHorarioNombre,
            gateHorarioDescripcion,
            gateHorarioCod
        },
    };

    return await axiosPost(body, credentials);
};
